import angular from 'angular';
import template from './video.tpl.html';

class VideoController {

  constructor($rootScope, $ocLazyLoad, $attrs, $window, $document, userService) {
    this.$rootScope = $rootScope;
    this.$attrs = $attrs;
    this.$window = $window;
    this.$document = $document;
    this.$userService = userService;
    this.$ocLazyLoad = $ocLazyLoad;
  }

  $onInit() {
    this.chkloaded = false;
    this.video = this.$attrs.video || this.$rootScope.page.header.video;
    this.ratio = this.$attrs.ratio || '16:9';
    this.playlist = this.$attrs.playlist ? 'playlistLinks=auto' : '';
    this.playlistvideo = "";
    this.autoplay = localStorage.getItem('wautoplay') || this.$attrs.autoplay ? false : true;
    this.type = /^\d+$/.test(this.video) ? 'vimeo' : 'wistia';
    this.user = {};
    this.$ocLazyLoad.load(this.type).then(() => {
      if(this.type == 'wistia') {
        this.initWistia();
      } else if(this.type == 'vimeo') {
        this.initVimeo();
      }
    });
    // this.$userService.getUserByEmailOrToken().then((result)=> {
    //   this.user = result.data.data;
    // });
  }

  initWistia() {
    this.$window._wq = this.$window._wq || [];
    this.$window._wq.push({ id: `mlr_video_${this.video}`, onEmbedded: (video) => {
      this.$rootScope.$apply(() => {
        this.$rootScope.page.wistia = video;
      })
      if(this.$attrs.track) {
        this.watchPlaylist(video);
      }
      if (video.state() !== "playing" && video.options.autoPlay) {
        video.play();
      }
      this.watchSecondchange(video);
      this.visibilitychange(video);
    }});
  }

  watchPlaylist(video) {
    this.return = video._hashedId;
    this.$rootScope.$apply(() => {
      this.$rootScope.page.header.ver = video._hashedId;
    })
    this.addActiveClass(video._hashedId);
    video.bind('percentwatchedchanged', (percent, lastPercent) => {
      if (percent >= .075 && lastPercent < .075) {
        var email = this.$userService.checkProperty(this.user.properties, 'email');
        if(email) {
          this.$userService.saveHSProperty(email, {video_watched: video._hashedId})
        }
      }
    });
    video.bind("end", (t) => {
    });
  }

  watchSecondchange(video) {
    this.chkloaded = true;
    let loadcontent = this.$rootScope.page.header.step;
    if(typeof loadcontent === 'string'  || loadcontent instanceof String) {
      let videosw = document.querySelector('body');
      video.bind('secondchange', (s) => {
        if (s > loadcontent && this.chkloaded) {
          this.chkloaded = false;               // Insert code to do something amazing here
          videosw.querySelector('.videosw').className = videosw.querySelector('.videosw').className.replace('d-none', 'd-block');
        }
      });
      video.bind('end', (s) => {
        if(this.chkloaded) {
          videosw.className = videosw.className.replace('d-none', 'd-block');
        }
      });
    }
  }

  visibilitychange(video) {
    // Handle page visibility change
    if(this.autoplay && !this.visibility) {
      var hidden, visibilityChange;
      if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
        hidden = "hidden";
        visibilityChange = "visibilitychange";
      } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
      } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
      }
      this.$window.addEventListener(visibilityChange, () => {
        if (document.visibilityState === 'hidden') {
          video.pause();
        } else {
          video.play();
        }
      }, false);
    }
  }

  initVimeo() {
    this.$window.Vimeo = this.$window.Vimeo || [];
    var video01Player = new this.$window.Vimeo.Player(this.video);
    video01Player.on('play', function() {
    });
  }

  addActiveClass(vid) {
    var header = document.getElementById("wistia-playlist");
    var btns = header.getElementsByClassName("link-primary");
    var current = header.getElementsByClassName("active")[0];
    if(current) {
      current.classList.remove("active");
    }
    document.querySelector('[href="#wistia_'+vid+'"]').classList.add("active");
  }

}

VideoController.$inject = ["$rootScope", "$ocLazyLoad", "$attrs", "$window", "$document" ,"userService"];

class VideoComponent {
  constructor() {
    this.bindings = {
      video: '@?',
      type: '@?',
      return: '=?',
      visibility: '@?'
    };
    this.template = template;
    this.controller = VideoController;
  }
}

export default angular
.module('mlrvideo.component', [])
.component('mlrvideo', new VideoComponent())
.name;
